export class TrailerTrait implements ex.IActorTrait {
    readonly leader: ex.Actor;
    followDistance = 16;
    constructor(leader: ex.Actor) {
        this.leader = leader;
    }
    public update(actor: ex.Actor, engine: ex.Engine, delta: number) {
        let directionToLeader = this.leader.pos.sub(actor.pos).normalize();
        let desiredToLeader = directionToLeader.scale(this.followDistance);
        actor.pos = this.leader.pos.sub(desiredToLeader);
        actor.vel = directionToLeader.scale(this.leader.vel.magnitude());
    }
}
